class MatLargeInfoSlider extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
    }
  
    connectedCallback() {
      if (this.isConnected && !this.initialized) {
        this.initialized = true;
  
        this.mql = window.matchMedia('(max-width: 768px)');
        this.mql.addListener(this.onMQLChange.bind(this));
  
        // Flag that is kept updated within the above change handler
        this.isShowingMobileView = this.mql.matches;
  
        this.waitForStylesheetAndLoad();
      }
    }
    
    init() {
      this.showViewBasedOnWidth();
    }
  
    waitForStylesheetAndLoad() {
      if (document.readyState == 'complete') {
        this.init();
      } else {
        window.addEventListener('load', () => {
          this.init();
        });
      }
    }
  
    /**
     * Drawers should be active on mobile only
     */
    onMQLChange(e) {
      this.isShowingMobileView = e.matches;
      this.showViewBasedOnWidth();
    }
  
    showViewBasedOnWidth() {
      if (this.isShowingMobileView) {
        this.showMobileView();
      } else {
        this.showDesktopView();
      }
    }
  
    showMobileView() {
        this.swiper = new Swiper('.LargeInfoSlider', {
            slidesPerView: 1.15,
            spaceBetween: 26,
            threshold: 0,
            initialSlide: 0,
            navigation: {
                nextEl: '.LargeInfoSlider__Nav .swiper-button-next',
                prevEl: '.LargeInfoSlider__Nav .swiper-button-prev',
            },
            pagination: {
                el: '.LargeInfoSlider__Pagination',
                type: 'bullets',
                clickable: true,
            },
        });
    }
  
    showDesktopView() {
      this.initSwipers();
    }
  
    initSwipers() {
      this.thumbsSwiper = new Swiper('.LargeInfoThumbs', {
        slidesPerView: 'auto',
        centeredSlides: true,
        initialSlide: 0,
        spaceBetween: 55,
        threshold: 15,
        a11y: false
      }); 
      this.swiper = new Swiper('.LargeInfoSlider', {
        slidesPerView: 1.2,
        centeredSlides: true,
        spaceBetween: 32,
        threshold: 15,
        initialSlide: 0,
        navigation: {
          nextEl: '.LargeInfoSlider__Nav .swiper-button-next',
          prevEl: '.LargeInfoSlider__Nav .swiper-button-prev',
        },
        pagination: {
          el: '.LargeInfoSlider__Pagination',
          type: 'bullets',
          clickable: true,
        },
        thumbs: {
          swiper: this.thumbsSwiper,
        },
        breakpoints: {
          769: {
            a11y: false,
            slidesPerView: 1,
            spaceBetween: 0,
          },
        },
        on: {
          afterInit: () => {
            // This is to fix a swiper bug where adding a swiper as a thumbnail resets
            // its 'slideToClickedSlide' param.
            this.thumbsSwiper.params.slideToClickedSlide = true;
          }
        },
      });
    }
  }
  customElements.define('home-large-info-slider', MatLargeInfoSlider);